import { EuiFlexGroup, EuiFlexItem } from "@elastic/eui";
import React, { useEffect, useState } from "react";
import { useMapDataToUiWithFilter } from "hooks/mapDataToOptions";
import { ButtonRow } from "styles/elements/main";
import { Button, SelectWithSearch } from "components";
import FilterLabel from "modules/shared/profiles/filters/FilterLabel";

const LocationsFilter = ({ setLocationsFilterOptinos, filterOptions, isFromClient }) => {
    // * fetch data for dropdowns
    const {
        data: clients,
        setSearchFilter: setClientSearchFilter,
        clearSearchFilter: clearClientSearchFilter,
    } = useMapDataToUiWithFilter("organizations");
    const {
        data: governorates,
        setSearchFilter: setgovernoratesSearchFilter,
        clearSearchFilter: cleargovernoratesSearchFilter,
    } = useMapDataToUiWithFilter("governorates");
    const {
        data: locationCategories,
        setSearchFilter: setLocationCategoriesSearchFilter,
        clearSearchFilter: clearLocationCategoriesSearchFilter,
    } = useMapDataToUiWithFilter("location-categories", "locationCategories");
    const {
        data: cities,
        setSearchFilter: setCitiesSearchFilter,
        clearSearchFilter: clearCitiesSearchFilter,
    } = useMapDataToUiWithFilter("cities");
    const {
        data: areas,
        setSearchFilter: setAreasSearchFilter,
        clearSearchFilter: clearAreasSearchFilter,
    } = useMapDataToUiWithFilter("areas");
    const locationTypes = [
        { label: "Drop off", value: "1" },
        { label: "Pick up", value: "0" },
        { label: "Pick up and Drop off", value: "2" },
    ];
    //* state
    const [filters, setFilters] = useState({});
    const [totalFilters, setTotalFilters] = useState(0);

    // *filters number
    useEffect(() => {
        const sum = Object?.values(filters)?.reduce((acc, curr) => acc + curr?.value?.length, 0);
        setTotalFilters(sum);
    }, [filterOptions]);
    // *clear all filters
    const handelClearAllFilters = () => {
        const updatedFilters = {};
        for (const filter in filters) {
            updatedFilters[filter] = { value: [] };
        }
        setFilters(updatedFilters);
        setLocationsFilterOptinos([]);
    };
    // * clear single filter
    const handleClearSingleFilter = (filterName) => {
        const filtered = { ...filterOptions[0] };
        delete filtered[filterName];
        setFilters((prev) => ({ ...prev, [filterName]: { value: [] } }));
        setLocationsFilterOptinos([filtered]);
    };
    // * apply btn
    const handleApplyFilter = (id, newFilters) => {
        const appliedOptions = [];
        const updatedFilters = newFilters || filters;
        for (const option in updatedFilters) {
            if (updatedFilters[option].id === id) {
                const filter = updatedFilters[option];
                appliedOptions.push({ ...updatedFilters, [option]: filter });
            }
        }
        setLocationsFilterOptinos(appliedOptions);
    };
    const handleChangedData = (value, name, id) => {
        const newFilters = {
            ...filters,
            [name]: { value, id },
        };
        setFilters(newFilters);
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < filterOptions?.length; i++) {
            if (newFilters[name]?.value?.length < filterOptions[i][name]?.value?.length) {
                handleApplyFilter(id, newFilters);
            }
        }
    };

    // *  buttons
    const ActionBtns = ({ name, id }) => (
        <ButtonRow>
            <Button
                name="Clear"
                type="button"
                btnStyle="secondBtn"
                onChange={() => handleClearSingleFilter(name)}
            />
            <Button
                name="Apply"
                onChange={() => handleApplyFilter(id)}
                type="button"
                btnStyle="primaryBtn"
            />
        </ButtonRow>
    );
    return (
        <>
            <FilterLabel
                handelClearAllFilters={handelClearAllFilters}
                filtersCount={totalFilters}
            />
            <EuiFlexGroup
                className="step-container"
                gutterSize="s"
            >
                <EuiFlexItem>
                    <SelectWithSearch
                        placeholder="Client"
                        name="organizationId"
                        customBtns={
                            <ActionBtns
                                name="organizationId"
                                id={1}
                            />
                        }
                        isEditable
                        disable={isFromClient}
                        value={filters?.organizationId?.value}
                        isMulti
                        handleChange={(value) => handleChangedData(value, "organizationId", 1)}
                        handleFilter={(filter) => {
                            setClientSearchFilter(filter);
                            return clients;
                        }}
                        options={clients}
                        onMenuClose={() => clearClientSearchFilter()}
                    />
                </EuiFlexItem>
                <EuiFlexItem>
                    <SelectWithSearch
                        placeholder="Category"
                        name="locationCategoryId"
                        customBtns={
                            <ActionBtns
                                name="locationCategoryId"
                                id={2}
                            />
                        }
                        value={filters?.locationCategoryId?.value}
                        isEditable
                        handleChange={(value) => handleChangedData(value, "locationCategoryId", 2)}
                        isMulti
                        handleFilter={(filter) => {
                            setLocationCategoriesSearchFilter(filter);
                            return locationCategories;
                        }}
                        options={locationCategories}
                        onMenuClose={() => clearLocationCategoriesSearchFilter()}
                    />
                </EuiFlexItem>
                <EuiFlexItem>
                    <SelectWithSearch
                        placeholder="Governorate"
                        name="governorateId"
                        isEditable
                        customBtns={
                            <ActionBtns
                                name="governorateId"
                                id={3}
                            />
                        }
                        isMulti
                        value={filters?.governorateId?.value}
                        options={governorates}
                        handleChange={(value) => handleChangedData(value, "governorateId", 3)}
                        handleFilter={(filter) => {
                            setgovernoratesSearchFilter(filter);
                            return governorates;
                        }}
                        onMenuClose={() => cleargovernoratesSearchFilter()}
                    />
                </EuiFlexItem>
                <EuiFlexItem>
                    <SelectWithSearch
                        placeholder="City"
                        name="cityId"
                        value={filters?.cityId?.value}
                        customBtns={
                            <ActionBtns
                                name="cityId"
                                id={4}
                            />
                        }
                        isEditable
                        isMulti
                        handleChange={(value) => handleChangedData(value, "cityId", 4)}
                        handleFilter={(filter) => {
                            setCitiesSearchFilter(filter);
                            return cities;
                        }}
                        onMenuClose={() => clearCitiesSearchFilter()}
                        options={cities}
                    />
                </EuiFlexItem>
                <EuiFlexItem>
                    <SelectWithSearch
                        placeholder="Area"
                        name="areaId"
                        isEditable
                        customBtns={
                            <ActionBtns
                                name="areaId"
                                id={5}
                            />
                        }
                        isMulti
                        value={filters?.areaId?.value}
                        handleChange={(value) => handleChangedData(value, "areaId", 5)}
                        handleFilter={(filter) => {
                            setAreasSearchFilter(filter);
                            return areas;
                        }}
                        onMenuClose={() => clearAreasSearchFilter()}
                        options={areas}
                    />
                </EuiFlexItem>
                <EuiFlexItem>
                    <SelectWithSearch
                        placeholder="Location type"
                        closeMenuOnSelect={true}
                        name="locationType"
                        isEditable={true}
                        customBtns={
                            <ActionBtns
                                name="locationType"
                                id={6}
                            />
                        }
                        value={filters?.locationType?.value}
                        handleChange={(value) => handleChangedData([value], "locationType", 6)}
                        options={locationTypes}
                    />
                </EuiFlexItem>
            </EuiFlexGroup>
        </>
    );
};

export default LocationsFilter;
